import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Heart, ArrowRight, Globe, Award } from 'lucide-react';
import { Link } from 'react-router-dom';
import { importedSiteImages, pastorBio } from '@/content/public-site-content';

export default function AboutPage() {
  return (
    <main className="mx-auto w-full max-w-6xl space-y-8 px-4 py-6 sm:px-6 lg:px-8 lg:py-10">
      <section className="overflow-hidden rounded-[2rem] border border-border/70 bg-card shadow-sm">
        <div className="grid gap-0 lg:grid-cols-[1.1fr_0.9fr]">
          <div className="space-y-5 p-8 sm:p-10">
            <Badge variant="outline" className="w-fit border-primary/30 bg-primary/5">
              <Heart className="mr-1 h-3 w-3 text-primary" />
              About Dr David
            </Badge>
            <div className="space-y-4">
              <h1 className="text-3xl font-bold tracking-tight sm:text-4xl lg:text-5xl">
                About Dr David
              </h1>
              <p className="text-base leading-7 text-muted-foreground sm:text-lg">
                {pastorBio.fullBio[0]}
              </p>
              <p className="text-base leading-7 text-muted-foreground sm:text-lg">
                {pastorBio.fullBio[1]}
              </p>
            </div>
            <div className="flex flex-wrap gap-3">
              <Button asChild>
                <Link to="/contact">
                  Contact Me
                  <ArrowRight className="ml-2 h-4 w-4" />
                </Link>
              </Button>
            </div>
          </div>
          <div className="relative flex min-h-[320px] items-end justify-center overflow-hidden bg-[radial-gradient(circle_at_top,_hsl(var(--primary)/0.14),_transparent_58%),linear-gradient(180deg,hsl(var(--muted))_0%,hsl(var(--background))_100%)] px-6 pt-8 sm:px-10">
            <img
              src={importedSiteImages.aboutPortrait}
              alt="Dr David Ogbueli"
              className="relative z-10 max-h-[520px] w-full max-w-[460px] object-contain object-bottom"
            />
            <div className="absolute inset-x-0 bottom-0 h-28 bg-gradient-to-t from-background/60 via-background/10 to-transparent" />
          </div>
        </div>
      </section>

      <section className="grid gap-6 lg:grid-cols-2">
        <Card className="border-border/70 bg-card/90">
          <CardContent className="space-y-4 p-8">
            <div className="flex items-center gap-3">
              <Globe className="h-5 w-5 text-primary" />
              <h2 className="text-xl font-semibold">Global impact</h2>
            </div>
            <p className="leading-7 text-muted-foreground">{pastorBio.fullBio[2]}</p>
            <p className="leading-7 text-muted-foreground">{pastorBio.fullBio[3]}</p>
          </CardContent>
        </Card>

        <Card className="border-border/70 bg-card/90">
          <CardContent className="space-y-4 p-8">
            <div className="flex items-center gap-3">
              <Award className="h-5 w-5 text-primary" />
              <h2 className="text-xl font-semibold">Leadership roles</h2>
            </div>
            <ul className="space-y-3 text-muted-foreground">
              {pastorBio.roles.map((role) => (
                <li key={role}>• {role}</li>
              ))}
            </ul>
            <p className="border-t border-border/60 pt-4 text-sm text-muted-foreground">
              {pastorBio.family}
            </p>
          </CardContent>
        </Card>
      </section>
    </main>
  );
}
